/*
 * @Description: file content
 * @Author: ljrong
 * @Date: 2024-08-13 20:21:40
 * @LastEditors: Xiaochun liu
 * @LastEditTime: 2025-01-13 14:11:55
 */

import Cookies from 'js-cookie'
import UAParser from 'ua-parser-js'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { dataUserLogin } from '@/api'
import { useUserStore } from '@/store'
function getQueryUuid(): string | null {
  const urlParams = new URLSearchParams(window.location.search)
  const uuid = urlParams.get('uuid')
  if (uuid) {
    localStorage.setItem('myuuid', uuid)
    return uuid
  }
  return null
}
export function useLoginData() {
  const userStore = useUserStore()
  const userInfo = computed(() => userStore.userInfo)

  const uuid = ref('')
  const browserInfo = ref({
    browser: '',
    device: '',
    engine: '',
    fingerprint: '',
    fingerprint2: '',
    mac: '',
    operTime: '',
    os: '',
  })
  const loginKey = ref('')

  async function init() {
    let isSocketConnected = false
    let socketConnectetTimer = null

    // getUuidByDoge()
    function loopGetUuid() {
      socketConnectetTimer = setTimeout(getUuidByDoge, 3000)
    }
    function getUuidByDoge() {
      if (!isSocketConnected) {
        // console.log('连接中...')
        try {
          const socket = new WebSocket(
            'ws://127.0.0.1:20118',
          )
          socket.onopen = function () {
            // console.log("连接成功");
            isSocketConnected = true
            socketConnectetTimer && clearInterval(socketConnectetTimer)
            socketConnectetTimer = null
            socket.send('getUuid')
          }
          socket.onmessage = function (e) {
            // console.log('收到信息:', e.data);
            if (e.data) {
              console.log('received: uuid')
            }
            uuid.value = e.data
          }

          socket.onclose = function () {
            // console.log("连接关闭");
            socketConnectetTimer && clearInterval(socketConnectetTimer)
            socketConnectetTimer = null

            loopGetUuid()
          }
          socket.onerror = function (err) {
            // console.log("连接错误", err);
          }
        } catch (error) {
          console.log('ws error: ', error)
        }
      }
    }
    const parser = new UAParser()
    const parserRes = parser.getResult()

    // uuid --- start
    const queryUuid = getQueryUuid()
    if (queryUuid) {
      uuid.value = queryUuid
    } else {
      const myuuid = localStorage.getItem('myuuid')
      if (myuuid) {
        uuid.value = myuuid
      }
    }
    // uuid --- end

    const fpPromise = FingerprintJS.load()
    // 创建一个FingerprintJS的实例，并传入配置对象

    const fp = await fpPromise
    const fpResult = await fp.get()
    // console.log(fpResult.visitorId); // 打印UUID

    browserInfo.value = {
      browser: `${parserRes.browser.name} ${parserRes.browser.version}`,
      device: parserRes.device.type ? `${parserRes.device.type} ${parserRes.device.vendor} ${parserRes.device.model}` : '',
      engine: `${parserRes.engine.name} ${parserRes.engine.version}`,
      fingerprint: fpResult.visitorId,
      fingerprint2: '',
      mac: Cookies.get('mac') || '',
      operTime: '',
      os: `${parserRes.os.name} ${parserRes.os.version}`,
    }
  }

  // 获取数据系统信息
  // code 系统编码，meiye-v2: 美业数据大脑，np: 全球新品，dssc: 数选，amz: 亚马逊数据洞察，amzen:亚马逊数据洞察英文版，npen: 新品英文版
  function getSystem(code: string) {
    const ajaxParams = {
      browserInfo: browserInfo.value,
      /**
       * 0- CoWork 中文版 1-CoWork英文版
       */
      from: 0,
      mac: Cookies.get('mac') || '',
      userId: userInfo.value.id,
      uuid: uuid.value,
      code,
    }

    return new Promise((resolve, reject) => {
      dataUserLogin(ajaxParams).then((res) => {
        resolve(res)
      }).catch((error) => {
        reject(error)
      })
    })
  }
  return { browserInfo, uuid, init, getSystem }
}
